export default __webpack_public_path__ + "static/media/logo.ce5bd8cb.svg";